import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Config from '@app/dev/config/main';
import { LoyalCard } from '@app/dev/actions/terminal';
import { useTranslation } from '@common/hooks/translation';
import { PopupContext } from '@app/dev/contexts/popup';
import { useBalance } from '../../hooks/balance';
import { POPUPS } from '@common/constants/popups';

import './style.scss';

const LoyalCardItem = () => {
  const t = useTranslation();
  const [{ openPopup }] = useContext(PopupContext);
  const balance = useBalance();
  const dispatch = useDispatch();
  const [lCard, setLCard] = useState(false);
  const loyalCard = useSelector((state) => state.terminal.loyalCard?.result);

  const openCardWrapper = () => setLCard(!lCard && loyalCard);

  const deleteCard = useCallback(() => {
    dispatch(LoyalCard(null));
    setLCard(false);
  }, [setLCard, dispatch]);

  const openLoyalCardPopup = () => {
    if (loyalCard) return;

    openPopup(POPUPS.LOYAL_CARD_INPUT_POPUP);
  };

  useEffect(() => {
    if (balance === 0) deleteCard();
  }, [balance, deleteCard]);

  if (!Config.main.useLoyalCardBarcode) return null;

  return (
    <div
      onClick={openLoyalCardPopup}
      className={`loyal-card-wrapper ${loyalCard ? 'member-card-applayed' : ''}`}
    >
      <div className="loyal-card-column-wrapper">
        <i className="global-icon icon-member-card" onClick={openCardWrapper} />
      </div>
      <p className="loyal-card-text">
        {loyalCard ? t('Member card applied') : t('Apply Loyalty Card')}
      </p>
      {loyalCard && (
        <div className="loyal-card-column-wrapper">
          <i onClick={deleteCard} className="global-icon icon-logout " />
        </div>
      )}
    </div>
  );
};

export default LoyalCardItem;
